import { render, staticRenderFns } from "./ScrollText.vue?vue&type=template&id=4f2ad7c8"
import script from "./ScrollText.vue?vue&type=script&lang=js"
export * from "./ScrollText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports